<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="银行名称" size="small">
              <el-select v-model="listQuery.bankName" placeholder="" style="width:180px" filterable clearable value-key="Projectid">
                <el-option v-for="(item,index) in bankList" :key="index" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="户名" size="small">
              <el-select v-model="listQuery.accountName" placeholder="" style="width:180px" filterable clearable value-key="Projectid">
                <el-option v-for="(item,index) in payCompList" :key="index" :value="item.companyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账户" size="small">
              <el-input v-model="listQuery.accountNo" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
          </el-form>
          <!-- <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div> -->
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item>杰小金设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="杰小薪设置" name="0"></el-tab-pane>
          <el-tab-pane label="杰小职设置" name="1"></el-tab-pane>
          <el-tab-pane label="杰小金设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <!-- <el-tab-pane label="增强学习" name="4"></el-tab-pane> -->
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="expList" :loading="isExping">导出</el-button>
          <el-button type="warning" size="small" @click="uploadHandel">导入</el-button>
          <el-button type="success" size="small" @click="stopHandel(true)">启用</el-button>
          <el-button type="danger" size="small" @click="stopHandel(false)">停用</el-button>
          <el-button type="primary" size="small" @click="addProTask">+添加</el-button>
          <!-- <el-button type="danger" size="small" @click="delHandel">删除</el-button> -->
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="taskNum" label="任务编号" min-width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="bankName" label="银行名称" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="accountName" label="户名" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="accountNo" label="账号" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="isEnable" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.isEnable == 1 ? '启用' : '停用' }}
            </template>
          </el-table-column>
          <el-table-column label="U盾密码" min-width="100" :show-overflow-tooltip="true" align="center">
            <template>******</template>
          </el-table-column>
          <el-table-column label="登录密码" min-width="100" :show-overflow-tooltip="true" align="center">
            <template>******</template>
          </el-table-column>
          <el-table-column prop="usbId" label="USBID" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="approvalUkeyNum" label="经办Ukey编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <!-- <el-table-column prop="isApprovalPresOk" label="经办Ukey是否按压OK" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.isApprovalPresOk == 1 ? '是' : '否' }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="status" label="经办按压设备编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="salaryIsDispatch" label="发薪是代发" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.salaryIsDispatch ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="goldenFingerCode" label="按压Ok代号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="isSupportPay" label="支持自动支付" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.isSupportPay == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="isPayRreAppro" label="支付需审批" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.isPayRreAppro == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="approvalUkeyNum" label="审批Ukey编号" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="isApprovalPresOk" label="审批Ukey是否按压OK" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.isApprovalPresOk == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" label="审核按压设备编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="name" label="交易明细操作日期" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="transaDetailsRunTime" label="交易明细操作时间" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="transactionStart" label="交易明细取值" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ !row.transactionStart || !row.transactionEnd ? '' : row.transactionStart + ' ~ ' +  row.transactionEnd}}
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="交易明细频次" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ !row.rate || !row.rateUnit ? '' : row.rate + '/' +  row.rateUnit}}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="交易明细自动导入" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="对账单操作日期" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="对账单操作时间" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="对账单取值" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" fixed="right" align="center" width="220">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
                <el-button type="text" size="small" @click="timeSetHandel(row)">设置任务时间</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="delHandle(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog :title="type == 'add' ? '添加' : '编辑'" :visible.sync="addTaskVisible" width="900px" class="res_dialog enter_dialog">
      <el-form ref="addTaskForm" :inline="true" :model="addTaskForm" :rules="rules" class="" label-width="100px" size="small">
        <el-form-item label="银行:" prop="bankName">
          <el-select v-model="addTaskForm.bankName" placeholder="" style="width:300px" filterable value-key="Projectid" :disabled="type!='add' ? true : false">
            <el-option v-for="(item,index) in bankList" :key="index" :label="item.code" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="户名:" prop="accountName">
          <el-select v-model="addTaskForm.accountName" placeholder="" style="width:300px" filterable value-key="Projectid" :disabled="type!='add' ? true : false">
            <el-option v-for="(item,index) in payCompList" :key="index" :value="item.companyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户:" prop="accountNo">
          <el-input v-model="addTaskForm.accountNo" size="small" style="width: 300px;" clearable :disabled="type!='add' ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="开户行:" prop="depositBank">
          <el-input v-model="addTaskForm.depositBank" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="U盾密码" prop="uhieldPwd">
          <div class="flex">
            <el-input v-model="addTaskForm.uhieldPwd" type="password" size="small" :style="`width: ${type == 'edit' ? '271px' : '300px'}`" clearable :disabled="type=='add' || isLock==false ? false : true"></el-input>
            <el-button type="text" size="small" style="margin-left: 5px;" @click="editPsw()" v-if="type=='edit' && isLock==true">修改</el-button>
          </div>
        </el-form-item>
        <el-form-item label="登录密码">
          <div class="flex">
            <el-input v-model="addTaskForm.loginPwd" type="password" size="small" :style="`width: ${type == 'edit' ? '271px' : '300px'}`"  clearable :disabled="type=='add' || isLock==false ? false : true"></el-input>
            <el-button type="text" size="small" style="margin-left: 5px;" v-if="type=='edit' && isLock==true" @click="editPsw()">修改</el-button>
          </div>
        </el-form-item>
        <el-form-item label="财务:">
          <el-select v-model="addTaskForm.financialUserId" placeholder="" style="width:300px" filterable @change="changeFin">
            <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="USBID">
          <el-input v-model="addTaskForm.usbId" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="发薪是代发">
          <div style="width: 300px;">
            <el-radio-group v-model="addTaskForm.salaryIsDispatch">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="按压Ok代号">
          <el-input v-model="addTaskForm.goldenFingerCode" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="支持自动支付">
          <div style="width: 300px;">
            <el-radio-group v-model="addTaskForm.isSupportPay">
              <el-radio :label="true">支持</el-radio>
              <el-radio :label="false">不支持</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="支付需审批">
          <div style="width: 300px;">
            <el-radio-group v-model="addTaskForm.isPayRreAppro">
              <el-radio :label="true">需要</el-radio>
              <el-radio :label="false">不需要</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="审批Ukey编号">
          <el-input v-model="addTaskForm.approvalUkeyNum" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTaskVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddTask" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog title="导入" :visible.sync="uploadVisible" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="uploadRules" ref="addTaskForm" :model="addTaskForm" class="" label-width="100px" size="small">
        <el-form-item label="导入Excel" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 设置时间频次 -->
    <el-dialog title="设置任务时间" :visible.sync="frequencyVisible" width="750px" class="res_dialog enter_dialog">
      <el-form ref="frequencyForm" :inline="true" :model="frequencyForm" class="" v-if="frequencyVisible" label-width="100px" size="small">
        <div class="timeTitle flex sb">
          <div>银行名称：{{ info.bankName }}</div>
          <div>户名：{{ info.accountName }}</div>
          <div>账户：{{ info.accountNo }}</div>
        </div>
        <el-divider></el-divider>
        <div class="timeItemTile">交易明细：</div>
        <el-form-item label="操作频次:" size="small">
          <div class="flex">
            每
            <el-input v-model="frequencyForm.rate" size="small" style="width:60px;margin:0 5px;" type="number"></el-input>
            <el-select v-model="frequencyForm.rateUnit" size="small" placeholder="" style="width: 80px;margin:0 5px">
              <el-option value="分"></el-option>
              <el-option value="小时"></el-option>
              <el-option value="天"></el-option>
              <el-option value="周"></el-option>
            </el-select>
            1次
          </div>
        </el-form-item>
        <el-form-item label="交易明细取值:" label-width="130px" size="small">
          <div class="flex">
            <el-select v-model="frequencyForm.transactionStart" size="small" placeholder="" style="width: 80px;margin:0 5px">
              <el-option label="当日" :value="0"></el-option>
              <el-option label="前1日" :value="1"></el-option>
              <el-option label="前2日" :value="2"></el-option>
              <el-option label="前3日" :value="3"></el-option>
              <el-option label="前4日" :value="4"></el-option>
              <el-option label="前5日" :value="5"></el-option>
              <el-option label="前6日" :value="6"></el-option>
            </el-select>
            <div style="margin-left: 10px;"> ~ </div>
            <el-select v-model="frequencyForm.transactionEnd" size="small" placeholder="" style="width: 80px;margin:0 5px">
              <el-option label="当日" :value="0"></el-option>
              <el-option label="前1日" :value="1"></el-option>
              <el-option label="前2日" :value="2"></el-option>
              <el-option label="前3日" :value="3"></el-option>
              <el-option label="前4日" :value="4"></el-option>
              <el-option label="前5日" :value="5"></el-option>
              <el-option label="前6日" :value="6"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="起止日期:" size="small">
          <div class="flex">
            <el-select v-model="addForm.cycleUnit" placeholder="" style="width:80px;margin-left: 10px;">
              <el-option value="每周"></el-option>
              <el-option value="每月"></el-option>
              <el-option value="每季度"></el-option>
              <el-option value="每年"></el-option>
            </el-select>
            <el-select v-model="addForm.start" placeholder="" filterable style="width:80px;margin-left: 10px;">
              <el-option v-for="(item, index) in 30" :key="index" :label="item + '日'" :value="item"></el-option>
            </el-select>
            <span style="margin-left: 10px;"> ~ </span>
            <el-select v-model="addForm.end" placeholder="" filterable style="width:80px;margin-left: 10px;">
              <el-option v-for="(item, index) in 30" :key="index" :label="item + '日'" :value="item"></el-option>
              <el-option value="月末" v-if="addForm.cycleUnit == '每月'"></el-option>
            </el-select>
            <el-time-picker v-model="addForm.startTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <span style="margin-left: 10px;"> ~ </span>
            <el-time-picker v-model="addForm.endTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <div class="blueName cp" @click="addTimeSet()" style="margin-left: 20px;">+添加</div>
          </div>
          <div v-for="(item, index) in frequencyForm.startingEndingTransaction" :key="index" class="flex" style="padding-left: 30px;">
            <span>{{ item.cycleUnit }} {{ item.start }} ~ {{ item.end }} </span>
            <span style="margin-left: 10px;">{{ item.startHours + ':' + item.startMinutes }} ~ {{ item.endHours + ':' + item.endMinutes }}</span>
            <span class="blueName cp" style="margin-left: 20px;" @click="delTimeSet(index)">删除</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="frequencyVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetFrequency" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="获取验证码" :visible.sync="showSms" width="500px" :show-close="false">
      <el-form>
        <el-form-item label="请输入验证码" label-width="100px">
          <el-input v-model="verifCode" style="width:120px" size="small"></el-input>
          <el-button type="primary" v-preventReClick size="small" style="margin-left:10px" :disabled="countdown>0" @click="sendSms">{{countdown == 0 ? '发送短信' : '重新发送（' + countdown + '）'}}</el-button>
        </el-form-item>
      </el-form>
      <div>注:验证码将发送到您的企微通知</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSms = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="checkSms" :loading="isBtnLoading">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          bankName: '',
          accountName: '',
          accountNo: ''
        },
        receiveEmail: '', //接受邮箱
        sendEmail: '', //发送邮箱
        receiving_server: '',
        sending_server: '',
        addTaskForm: {
          id: '',
          bankName: '',
          accountName: '',
          accountNo: '',
          depositBank: '',
          uhieldPwd: '', //U盾密码
          loginPwd: '', //登陆密码
          financialUserId: '',
          financialName: '',
          usbId: '',
          salaryIsDispatch: null, //发薪是代发
          goldenFingerCode: '', //按压Ok代号
          isSupportPay: true,
          isPayRreAppro: true,
          approvalUkeyNum: ''
        },
        taskProject: '',
        isExping: false,
        fileList: [],
        uploadVisible: false,
        showDropScreen: -1,
        activeName: '2',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        uploadRules: {},
        addTaskVisible: false,
        isBtnLoading: false,
        uploadForm: {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        flowSetVisible: false,
        projectName: '',
        frequencyVisible: false,
        frequencyForm: {
          id: '',
          rate: null, //操作频次
          rateUnit: '', //操作频次单位
          transactionStart: null, //交易明细取值1
          transactionEnd: null, //交易明细取值2
          startingEndingTransaction: [{ //交易明细起止时间
            cycleUnit: '',
            start: null,
            end: null,
            startHours: null,
            endHours: null,
            startMinutes: null,
            endMinutes: null
          }]
        },
        addForm: {
          cycleUnit: '',
          start: null,
          end: null,
          startTime: '',
          endTime: '',
        },
        showSms: false,
        emailForm: {
          id: '',
          receiveEmail: '',
          sendEmail: '',
          password: ''
        },
        rules: {
          bankName: {
            required: true,
            message: '请选择银行',
            trigger: 'change'
          },
          accountName: {
            required: true,
            message: '请选择户名',
            trigger: 'change'
          },
          accountNo: {
            required: true,
            message: '请选择账户',
            trigger: 'change'
          },
          depositBank: {
            required: true,
            message: '请选择开户行',
            trigger: 'change'
          },
          uhieldPwd: {
            required: true,
            message: '请输入U盾密码',
            trigger: 'blur'
          },
          loginPwd: {
            required: true,
            message: '请输入登陆密码',
            trigger: 'blur'
          },
        },
        bankList: [],
        accountList: [],
        payCompList: [], //我方公司列表
        type: '',
        isLock: true,
        verifCode: '',
        countdown: 0,
        timer: null,
        userList: [], //用户列表
      }
    },
    created() {
      this.getList();
      this.GetDicList();
      this.getlegalsubjectlist();
      this.getUserList();
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      //获取银行列表
      GetDicList() {
        let data = {
          parentId: 75
        }
        xz.AdvanceFun(data, 'GetDicList').then(res => {
          if (res.status == 'ok') {
            this.bankList = res.data
          } else {
            this.bankList = [];
          }
        })
      },
      //获取我方和对方账户和开户行
      getlegalsubjectlist() {
        let str = `?pageNum=${1}&pageSize=${10000}`
        xz.ArdCurStatGetFun('GetLegalSubjectsList', str).then(res => {
          if (res.status == 'ok') {
            this.payCompList = res.data.date
          } else {
            this.payCompList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.GetBusiBankTaskSettingList();
      },
      GetBusiBankTaskSettingList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetBusiBankTaskSettingList').then(res => {
          if (res.status === 'ok') {
            console.log(this.tableData);
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab(tab) {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/settlementTask'
          })
        } else if (this.activeName == '1') {
          this.$router.push({
            path: '/jobTask'
          })
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '4') {
          this.$router.push({
            path: '/dict'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.$router.push({
            path: '/ruleSet',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      uploadHandel() {
        this.uploadForm.fileUrl = '';
        this.fileList = [];
        this.isBtnLoading = false;
        this.uploadVisible = true;
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.uploadForm.fileUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.uploadForm.fileUrl = res;
          } else {
            this.uploadForm.fileUrl = ''
          }
        });
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20241223104534570.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "导入拆分模版.xlsx";
        aTag.click();
      },
      confirmUpload() {
        if (this.uploadForm.fileUrl) {
          this.isBtnLoading = true;
          xz.RPAFun(this.uploadForm, 'ImportStatementTaskSettings').then(res => {
            if (res.status == 'ok') {
              this.isBtnLoading = false;
              this.getList();
              this.uploadVisible = false;
              this.$message.success("导入成功！");
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      addProTask() {
        this.type = 'add';
        this.addTaskForm = {
          id: '',
          bankName: '',
          accountName: '',
          accountNo: '',
          depositBank: '',
          uhieldPwd: '',
          loginPwd: '',
          usbId: '',
          financialUserId: '',
          financialName: '',
          salaryIsDispatch: null, //发薪是代发
          goldenFingerCode: '', //按压Ok代号
          isSupportPay: true,
          isPayRreAppro: true,
          approvalUkeyNum: ''
        }
        this.isBtnLoading = false;
        this.addTaskVisible = true;
      },
      getUserList() {
        let dataPage = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        };
        xz.getauthUserInfoByorgancode(dataPage).then((res) => {
          if (res && res.totalcount > 0) {
            this.userList = res.msg;
          } else {
            this.userList = [];
          }
        });
      },
      editHandle(row) {
        this.type = 'edit'
        this.addTaskForm = {
          id: row.id,
          bankName: row.bankName,
          accountName: row.accountName,
          accountNo: row.accountNo,
          depositBank: row.depositBank,
          uhieldPwd: row.uhieldPwd,
          loginPwd: row.loginPwd,
          usbId: row.usbId,
          financialUserId: row.financialUserId,
          financialName: row.financialName,
          salaryIsDispatch: row.salaryIsDispatch,
          goldenFingerCode: row.goldenFingerCode,
          isSupportPay: row.isSupportPay,
          isPayRreAppro: row.isPayRreAppro,
          approvalUkeyNum: row.approvalUkeyNum
        }
        this.isBtnLoading = false;
        this.isLock = true;
        this.addTaskVisible = true;
      },
      changeAccount(val) {
        if (val) {
          let d = {
            pageNumber: 1,
            pageSize: 10,
            accountName: val,
            accountNo: '',
            recordDate: ''
          }
          xz.ArdCurStat(d, 'GetBusiBankBalancePageList').then(res => {
            if (res.status == 'ok') {
              this.accountList = res.data.dataList;
            }
          })
        }
      },
      confirmAddTask() {
        this.$refs.addTaskForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.ArdCurStat(this.addTaskForm, 'AddUpdataBusiBankTaskSetting').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.addTaskVisible = false;
                this.isBtnLoading = false;
                this.$message.success('添加成功！')
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      stopHandel(status) {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                ids: arr,
                isEnable: status
              }
              xz.ArdCurStat(d, 'EnableDisableBusiBankTaskSetting').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('操作成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      delHandle(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'AddUpdataBusiBankTaskSetting').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('删除成功！')
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })

      },
      expList() {
        // this.isExping = true;
        // xz.exportRPA(this.listQuery, 'ExportTaskSettings').then(res => {
        //   if (res) {
        //     try {
        //       var data = new Blob([res], {
        //         type: "application/vnd.ms-excel;charset=utf-8"
        //       });
        //       var downloadUrl = window.URL.createObjectURL(data);
        //       var anchor = document.createElement("a");
        //       anchor.href = downloadUrl;
        //       anchor.download = "任务结算单设置导出.xlsx";
        //       anchor.click();
        //       window.URL.revokeObjectURL(data);
        //       this.isExping = false;
        //     } catch (e) {
        //       this.isExping = false;
        //       this.$message.error('导出异常')
        //     }
        //   } else {
        //     this.isExping = false;
        //     this.$message.error('导出异常')
        //   }
        // })
      },
      timeSetHandel(row) {
        this.isBtnLoading = false;
        this.info = row;
        this.frequencyVisible = true;
        this.frequencyForm = {
          id: row.id,
          rate: row.rate, //操作频次
          rateUnit: row.rateUnit, //操作频次单位
          transactionStart: row.transactionStart, //交易明细取值1
          transactionEnd: row.transactionStart, //交易明细取值2
          startingEndingTransaction: [],
        }
        try {
          const originalArray = eval(row.transaDetailsRunTime);
          this.frequencyForm.startingEndingTransaction = originalArray.map(item => {
            const newItem = {};
            for (const key in item) {
              if (item.hasOwnProperty(key)) {
                // 将字段名首字母转为小写
                const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                newItem[newKey] = item[key];
              }
            }
            return newItem;
          });
        } catch (e) {
          console.log('出错，', e);
        }
      },
      addTimeSet() {
        if (this.addForm.cycleUnit && this.addForm.start && this.addForm.end && this.addForm.startTime && this.addForm.endTime) {
          let d = {
            cycleUnit: this.addForm.cycleUnit,
            start: this.addForm.start,
            end: this.addForm.end,
            startHours: this.addForm.startTime.split(':')[0],
            endHours: this.addForm.endTime.split(':')[0],
            startMinutes: this.addForm.startTime.split(':')[1],
            endMinutes: this.addForm.endTime.split(':')[1]
          }
          this.frequencyForm.startingEndingTransaction.push(d)
          this.addForm = {
            cycleUnit: '',
            start: '',
            end: '',
            startTime: '',
            endTime: ''
          }
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      delTimeSet(i) {
        this.frequencyForm.startingEndingTransaction.splice(i, 1)
      },
      confirmSetFrequency() {
        if (this.addForm.cycleUnit) {
          this.addTimeSet();
        }
        if (this.frequencyForm.startingEndingTransaction.length > 0) {
          this.isBtnLoading = true;
          xz.ArdCurStat(this.frequencyForm, 'TaskRunnableTimeBusiBankTaskSetting').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isBtnLoading = false;
              this.$message.success('保存成功');
              this.frequencyVisible = false;
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      editPsw() {
        this.countdown = 0;
        this.verifCode = '';
        this.isBtnLoading = false;
        this.showSms = true;
      },
      sendSms() {
        xz.ArdCurStatGetFun('SendBankPwdVerificationCode', `?Id=${this.addTaskForm.id}`).then(res => {
          if (res.status == 'ok') {
            this.$message.success('验证码发送成功');
            this.timecount()
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      timecount() {
        const TIME_COUNT = 60; //倒计时60秒
        if (!this.timer) {
          this.countdown = TIME_COUNT;
          this.isDisabled = true;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      checkSms() {
        if (this.verifCode) {
          this.isBtnLoading = true;
          let str = `?Id=${this.addTaskForm.id}&VerifCodeStr=${this.verifCode}`
          xz.ArdCurStatGetFun('CheckBankPwdCode', str).then(res => {
            if (res.status == 'ok') {
              this.$message.success('已解除密码锁定');
              this.isLock = false;
              this.isBtnLoading = false;
              this.showSms = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      changeFin(val) {
        if (val) {
          let item = this.userList.find(e => e.Userid == val);
          this.addTaskForm.financialName = item.Username;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .timeTitle {
    padding: 0 20px;
  }

  .timeItemTile {
    font-size: 16px;
    margin-bottom: 10px;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>